<template>
  <v-form ref="form" v-model="valid" @submit.prevent="submit" :lazy-validation="true">
    <v-card>
      <v-card-title>
        <span class="headline">{{ titlePrefix }} Side order</span>
      </v-card-title>
      <v-card-text>
        <v-text-field name="sideordername" v-model="ownItem.name" label="Name" :rules="stringValidation" autocomplete="off"></v-text-field>

        <v-text-field name="price" v-model="ownItem.price" label="Price" suffix=":-" type="tel" :rules="priceValidation" autocomplete="off"></v-text-field>

        <v-select :items="itemGroupsOptions" v-model="ownItem.itemgroup" label="Item group" :rules="stringValidation"></v-select>

        <v-row>
          <v-col cols="6">
            <v-text-field
              name="account number"
              label="Account number"
              v-model="ownItem.account_number"
              type="tel"
              :rules="accountValidation"
              :placeholder="!!selectedItemGroup && !!selectedItemGroup.account_number ? selectedItemGroup.account_number : ''"
              :persistent-placeholder="!!selectedItemGroup && !!selectedItemGroup.account_number"
            />
          </v-col>

          <v-col cols="6">
            <v-text-field
              name="cost center"
              label="Cost Center"
              v-model="ownItem.cost_center"
              type="tel"
              :placeholder="!!selectedItemGroup && !!selectedItemGroup.cost_center ? selectedItemGroup.cost_center : ''"
              :persistent-placeholder="!!selectedItemGroup && !!selectedItemGroup.cost_center"
            />
          </v-col>
        </v-row>

        <v-checkbox
          v-model="ownItem.hidden"
          label="Hidden"
          messages="Hidden side orders are not shown in the app and can't be bought"
        ></v-checkbox>
      </v-card-text>
      <v-card-actions>
        <v-btn depressed :disabled="!valid" :loading="isSaving" color="primary" type="submit">Save</v-btn>
        <v-btn text @click="cancel" color="primary">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import {getItemById} from '@dynapp/wc-api-generic';
function isNumeric(n) {
  return /^[0-9]+$/g.test(n);
}

export default {
  props: {
    item: {
      type: Object
    },
    itemGroups: {
      type: Array
    }
  },
  data () {
    return {
      valid: true,
      stringValidation: [v => (v != null && v !== '') || 'Cannot be empty'],
      accountValidation: [v => !v || /^\d*$/.test(v) || 'Only numbers'],
      priceValidation: [
        v => v !== '' || 'Cannot be empty',
        v => v != null || 'Must be a number',
        v => isNumeric(v) || 'Must be a whole number',
        v => v >= 0 || 'Can\'t be negative'
      ],
      ownItem: {},
      imageName: 'dync-appshop-product-image.jpg',
      image: null,
      hadImage: false
    }
  },
  computed: {
    isSaving () {
      return this.$store.getters.isLoadingFor(['sideorders.create', 'sideorders.update']);
    },
    titlePrefix () {
      return this.ownItem.id ? 'Edit' : 'Add';
    },
    itemGroupsOptions () {
      var options = this.itemGroups.slice(0);
      options = options.map((item) => {
        return {
          value: item.id,
          text: item.name +'  (Vat '+ item.vat + '%)'
        }
      });
      options.sort((a, b) => {
        if (a.text > b.text) {
          return 1;
        } else if (a.text < b.text) {
          return -1;
        } else {
          return 0
        }
      });
      return options;
    },
    selectedItemGroup () {
      if (this.ownItem && this.ownItem.itemgroup) {
        return this.getItemGroupById(this.ownItem.itemgroup);
      }
      return null;
    }
  },
  watch: {
    item: {
      immediate: true,
      handler (newVal) {
        this.setOwnItem(newVal);
      }
    }
  },
  methods: {
    setOwnItem (item) {
      if (item) {
        this.ownItem = Object.assign({}, item);
      } else {
        this.ownItem = {};
      }
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    submit () {
      if (!this.$refs.form.validate()) {
        return;
      }
      const item = Object.assign({}, this.ownItem);

      this.$emit('submit', item);
    },
    cancel () {
      this.$emit('cancel');
    },
    reset () {
      this.setOwnItem(null);
    },
    getItemGroupById (id) {
      return getItemById(this.itemGroups, id);
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
